import React from "react";
import style from "./Details.module.scss";
import SkeletonLoader from "../../../../components/skeleton-loader";

function DetailsSkeleton() {
  return (
    <div className={style.loader_section}>
      <div className={style.skeleton_desktop}>
      <div className={style.skeletonHeader}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div className={style.skeletonHeaderLeftTop}>
            <SkeletonLoader variant="circular" width="24px" height="24px" />
            <SkeletonLoader variant="text" width="102px" height="24px" />
          </div>
          <div className={style.skeletonMenu}>
            <SkeletonLoader variant="circular" width="24px" height="24px" />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div className={style.skeletonHeaderLeft}>
            <SkeletonLoader
              variant="text"
              width="150px"
              height="25px"
              className={style.skeletonTitle}
            />
            <div className={style.skeletonHeaderLeftBottom}>
              <SkeletonLoader variant="circular" width="12px" height="12px" />

              <SkeletonLoader
                variant="text"
                width="100px"
                height="16px"
                className={style.skeletonButton}
              />
            </div>
          </div>
          <div className={style.skeletonActions}>
            <SkeletonLoader
              variant="rectangular"
              style={{ borderRadius: "6px" }}
              width="67px"
              height="25px"
            />
            <SkeletonLoader
              variant="rectangular"
              style={{ borderRadius: "6px" }}
              width="151px"
              height="25px"
            />
          </div>
        </div>
      </div>

      {/* Main Content - Three Columns */}
      <div className={style.skeletonContent}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((column) => (
          <div key={column} className={style.skeletonCard}>
            <SkeletonLoader
              variant="text"
              width="80%"
              height="32px"
              className={style.skeletonTextLine}
            />
            <SkeletonLoader
              variant="text"
              width="60%"
              height="16px"
              className={style.skeletonTextLine}
            />
          </div>
        ))}
      </div>

      <div className={style.skeletonTabs}>
        {[1, 2, 3, 4, 5, 6].map((tab) => (
          <SkeletonLoader
            key={`tab-${tab}`}
            variant="rectangular"
            width="90px"
            height="24px"
            className={style.skeletonTab}
          />
        ))}
      </div>

      <div className={style.skeletonChartItem}>
        <div className={style.skeletonChartItemHeader}>
          <SkeletonLoader variant="text" width="100px" height="25px" />

          <div className={style.skeletonChartItemHeaderRight}>
            <SkeletonLoader variant="text" width="100px" height="25px" />
            <SkeletonLoader variant="text" width="100px" height="25px" />
          </div>
        </div>
        <div className={style.skeletonChartItemContent}>
          <SkeletonLoader variant="rectangular" width="100%" height="350px" />
        </div>
      </div>

      <div className={style.skeletonChartItem} style={{ marginTop: "32px" }}>
        <div className={style.skeletonChartItemHeader}>
          <SkeletonLoader variant="text" width="100px" height="25px" />
        </div>
        <div className={style.skeletonChartItemContent}>
          <SkeletonLoader variant="circular" width="300px" height="300px" />
        </div>
      </div>

      <div className={style.skeletonTabs} style={{ marginTop: "56px" }}>
        {[1, 2, 3, 4].map((tab) => (
          <SkeletonLoader
            key={`tab-bottom-${tab}`}
            variant="rectangular"
            width="90px"
            height="24px"
            className={style.skeletonTab}
          />
        ))}
      </div>

      <SkeletonLoader
        variant="rectangular"
        style={{
          borderRadius: "8px",
          marginTop: "24px",
        }}
        width="100%"
        height="88px"
      />
      </div>

      <div className={style.skeleton_mobile}>
        <div className={style.skeleton_mobile_header}>
          <SkeletonLoader
            variant="text"
            width="180px"
            height="25px"
            className={style.skeleton_mobile_title}
          />
          <div className={style.skeleton_mobile_status}>
            <SkeletonLoader variant="circular" width="12px" height="12px" />
            <SkeletonLoader variant="text" width="120px" height="16px" />
          </div>
        </div>
        <div className={style.skeleton_mobile_tabs}>
          {[1, 2, 3, 4, 5, 6].map((tab) => (
            <SkeletonLoader
              key={`mobile-tab-${tab}`}
              variant="rectangular"
              width="70px"
              height="24px"
              className={style.skeleton_mobile_tab}
            />
          ))}
        </div>
        <div className={style.skeleton_mobile_stats}>
          {[1, 2, 3, 4, 5, 6].map((card) => (
            <div key={`mobile-card-${card}`} className={style.skeleton_mobile_card}>
              <SkeletonLoader variant="text" width="70%" height="20px" />
              <SkeletonLoader variant="text" width="50%" height="14px" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DetailsSkeleton;
